import { createSelector } from 'reselect'

export const getBookingState = state => state.booking

export const getBookingServices = createSelector(
  getBookingState,
  bookingState => bookingState.services
)

export const getSelectedDay = createSelector(
  getBookingState,
  bookingState => bookingState.selectedDay
)

export const getSelectedHour = createSelector(
  getBookingState,
  bookingState => bookingState.selectedHour
)

export const shouldShowDimensioniPneumatico = createSelector(
  getBookingState,
  bookingState =>
    bookingState.services.some(
      service => service.tipoWeb === 'pneumatici_nuovi' || service.richiestaDimensioni
    )
)

export const shouldShowTarga = createSelector(
  getBookingState,
  bookingState =>
    bookingState.services.some(service => service.tipoWeb === 'pneumatici_cd' || service.richiestaTarga)
)

export const canGoToStep1 = createSelector(
  getBookingState,
  bookingState => bookingState.services.length > 0
)

export const canGoToStep2 = createSelector(
  getBookingState,
  bookingState => bookingState.selectedDay && bookingState.selectedHour
)
